import { Routes, Route, Navigate } from "react-router-dom";
import { AuthPage } from "./pages/auth/AuthPage";
import { VerifyEmailPage } from "./pages/auth/VerifyEmailPage";
import { ResetPasswordPage } from "./pages/auth/ResetPasswordPage";
import { AppShell } from "./components/layout/AppShell";
import { DashboardPage } from "./pages/DashboardPage";
import { JobListPage } from "./pages/jobs/JobListPage";
import { JobDetailPage } from "./pages/jobs/JobDetailPage";
import { NewJobPage } from "./pages/jobs/NewJobPage";
import { ApiKeysPage } from "./pages/keys/ApiKeysPage";
import { CredentialsPage } from "./pages/credentials/CredentialsPage";
import { IntegrationsPage } from "./pages/integrations/IntegrationsPage";
import { OrgSettingsPage } from "./pages/settings/OrgSettingsPage";
import { UsersPage } from "./pages/UsersPage";
import { OrganizationsPage } from "./pages/admin/OrganizationsPage";
import { OrganizationDetailPage } from "./pages/admin/OrganizationDetailPage";
import { RolesPage } from "./pages/admin/RolesPage";
import { AccessCodesPage } from "./pages/admin/AccessCodesPage";
import { FeatureFlagsPage } from "./pages/admin/FeatureFlagsPage";
import { AcceptInvitePage } from "./pages/auth/AcceptInvitePage";
import { CliLoginPage } from "./pages/auth/CliLoginPage";
import { Toaster } from "./components/ui/toast";

export function App() {
  return (
    <>
      <Routes>
        {/* One unified page for both — see AuthPage's own header comment.
          "/signup" kept as a route (not just a redirect) so existing
          bookmarks/links still resolve; it renders the identical page. */}
        <Route path="/login" element={<AuthPage />} />
        <Route path="/signup" element={<AuthPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/accept-invite" element={<AcceptInvitePage />} />
        <Route path="/cli-login" element={<CliLoginPage />} />

        <Route element={<AppShell />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/jobs" element={<JobListPage />} />
          <Route path="/jobs/new" element={<NewJobPage />} />
          <Route path="/jobs/:id" element={<JobDetailPage />} />
          <Route path="/keys" element={<ApiKeysPage />} />
          <Route path="/credentials" element={<CredentialsPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/settings" element={<OrgSettingsPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/admin/orgs" element={<OrganizationsPage />} />
          <Route path="/admin/orgs/:id" element={<OrganizationDetailPage />} />
          <Route path="/admin/roles" element={<RolesPage />} />
          <Route path="/admin/codes" element={<AccessCodesPage />} />
          <Route path="/admin/flags" element={<FeatureFlagsPage />} />
        </Route>

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
      <Toaster />
    </>
  );
}
